import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "semantic-ui-react";
import { useCleanupAndCreateRequest, usePostRequestAction } from "../../hooks";

export const RequestsModal = ({
  open,
  onClose,
  draftId,
  draftTitle,
  datasetTypeCode,
  requestType,
  requestHeader = "Create request confirm",
  confirmationMessage = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  const [requestCreated, setRequestCreated] = useState(false);
  const [requestData, setRequestData] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const cancelTriggered = useRef(false);

  const { mutate: checkAndCreate, isLoading: isRequestCreating } =
    useCleanupAndCreateRequest();
  const actionMutation = usePostRequestAction();

  useEffect(() => {
    if (open) {
      checkAndCreate(
        { draftId, requestType, draftTitle, datasetTypeCode },
        {
          onSuccess: (data) => {
            setRequestCreated(true);
            setRequestData(data);
          },
        },
      );
    }
  }, [open]);

  const handleModalClose = () => {
    if (requestCreated && requestData && !cancelTriggered.current) {
      cancelTriggered.current = true;
      setActionLoading(true);
      actionMutation.mutate(requestData.links.actions.cancel, {
        onSettled: () => {
          setActionLoading(false);
          onClose();
        },
      });
    } else {
      onClose();
    }
  };

  const handleAction = (actionType) => {
    if (!requestData) return;
    setActionLoading(true);
    if (actionType === "cancel") cancelTriggered.current = true;
    const actionUrl = requestData.links.actions[actionType];
    actionMutation.mutate(actionUrl, {
      onSettled: () => {
        setActionLoading(false);
        onClose();
        if (actionType === "submit") location.reload();
      },
    });
  };

  return (
    <Modal open={open} onClose={handleModalClose} size="small">
      <Modal.Header>{requestHeader}</Modal.Header>
      <Modal.Content>
        <p>
          {isRequestCreating
            ? "Preparing..."
            : requestCreated
              ? confirmationMessage
              : "Error preparing request."}
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={() => handleAction("cancel")}
          disabled={isRequestCreating || actionLoading}
          negative
        >
          {cancelText}
        </Button>
        <Button
          positive
          onClick={() => handleAction("submit")}
          disabled={isRequestCreating || actionLoading}
        >
          {confirmText}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

RequestsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  draftId: PropTypes.string.isRequired,
  draftTitle: PropTypes.string,
  datasetTypeCode: PropTypes.string,
  requestType: PropTypes.string.isRequired,
  requestHeader: PropTypes.string.isRequired,
  confirmationMessage: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
};
